export const PAIRING_REQUIRED_ORDER_SOURCES = ['netpincer', 'wolt', 'webshop'];

export const getOrderPairingStats = (order = {}) => {
    const requiresPairing = PAIRING_REQUIRED_ORDER_SOURCES.includes(order?.orderFrom);

    if (!requiresPairing) {
        return {
            requiresPairing: false,
            totalPairableItems: 0,
            pairedItems: 0,
            unpairedItems: 0,
            allPaired: true,
            hasUnpairedItems: false,
        };
    }

    const pairableEntries = [];

    (order?.items || []).forEach((item) => {
        pairableEntries.push(item);

        (item?.extras || []).forEach((extra) => {
            pairableEntries.push(extra);
        });
    });

    const totalPairableItems = pairableEntries.length;
    const pairedItems = pairableEntries.filter(entry => Boolean(entry?.item)).length;
    const unpairedItems = Math.max(totalPairableItems - pairedItems, 0);
    const allPaired = totalPairableItems === 0 || unpairedItems === 0;
    const hasUnpairedItems = totalPairableItems > 0 && unpairedItems > 0;

    return {
        requiresPairing,
        totalPairableItems,
        pairedItems,
        unpairedItems,
        allPaired,
        hasUnpairedItems,
    };
};

export const compareOrdersByPairingPriority = (firstOrder, secondOrder) => {
    const firstPairing = getOrderPairingStats(firstOrder);
    const secondPairing = getOrderPairingStats(secondOrder);

    if (firstPairing.hasUnpairedItems !== secondPairing.hasUnpairedItems) {
        return firstPairing.hasUnpairedItems ? -1 : 1;
    }

    return new Date(secondOrder?.createdAt || 0) - new Date(firstOrder?.createdAt || 0);
};

